import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject, replaceLastPoint } from "../shared";
export function calculateSchiffPitchforkGeometry(drawing, scales) {
    const [pivotPoint, leftPoint, rightPoint] = drawing.points;
    if (!pivotPoint || !leftPoint || !rightPoint)
        return null;
    const pivot = chartPointToPixel(pivotPoint, scales);
    const leftSwing = chartPointToPixel(leftPoint, scales);
    const rightSwing = chartPointToPixel(rightPoint, scales);
    // Schiff offset: 50% of P0-P1 distance
    const offsetX = (leftSwing.x - pivot.x) * 0.5;
    const offsetY = (leftSwing.y - pivot.y) * 0.5;
    const shiftedPivot = {
        x: pivot.x + offsetX,
        y: pivot.y + offsetY,
    };
    const midpoint = {
        x: (leftSwing.x + rightSwing.x) / 2,
        y: (leftSwing.y + rightSwing.y) / 2,
    };
    const direction = {
        x: midpoint.x - shiftedPivot.x,
        y: midpoint.y - shiftedPivot.y,
    };
    // Extend lines to viewport edges
    const extend = 10000;
    const medianEnd = {
        x: shiftedPivot.x + direction.x * extend,
        y: shiftedPivot.y + direction.y * extend,
    };
    // Upper parallel line (through leftSwing)
    const upperEnd = {
        x: leftSwing.x + direction.x * extend,
        y: leftSwing.y + direction.y * extend,
    };
    // Lower parallel line (through rightSwing)
    const lowerEnd = {
        x: rightSwing.x + direction.x * extend,
        y: rightSwing.y + direction.y * extend,
    };
    return {
        pivot: shiftedPivot,
        leftSwing,
        rightSwing,
        medianLine: { start: shiftedPivot, end: medianEnd },
        upperLine: { start: leftSwing, end: upperEnd },
        lowerLine: { start: rightSwing, end: lowerEnd },
    };
}
const SchiffPitchfork = {
    name: "schiffPitchfork",
    createDraft: (startPoint) => createDrawingObject("schiffPitchfork", [startPoint, startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default SchiffPitchfork;
